import { useMemo } from 'react'

import useCategory from 'components/GamesNavBar/hooks/useCategory'
import useSearch from 'components/GamesNavBar/hooks/useSearch'
import { useSelectedGames } from 'containers/GamesBlock/hooks/useSelectedGames'
import { getFilters } from 'containers/GamesBlock/hooks/utils'
import useCurrentCategory from 'utils/hooks/queries/games/useCurrentCategory'

export function useFilteredGames() {
  const { search } = useSearch()
  const { category } = useCategory()
  const { data: currentCategory } = useCurrentCategory()
  const filters = useMemo(() => getFilters(category, search, currentCategory), [category, search, currentCategory])
  const { selectedGames, isPending } = useSelectedGames({ filters })

  const selectedSlugs = useMemo(
    () =>
      currentCategory?.isProvider
        ? currentCategory.games.filter((categoryGame) =>
            selectedGames.some((selectedGame) => categoryGame.slug === selectedGame.slug),
          )
        : selectedGames.map((slug) => slug),
    [selectedGames, currentCategory],
  )

  return { selectedSlugs, isPending }
}
